import { render, staticRenderFns } from "./AdGroups.vue?vue&type=template&id=270b6666"
import script from "./AdGroups.vue?vue&type=script&lang=js"
export * from "./AdGroups.vue?vue&type=script&lang=js"
import style0 from "./AdGroups.vue?vue&type=style&index=0&id=270b6666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports